import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invalidDurationFormat: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.invalid-duration-format',
		defaultMessage: 'Goals can be empty or defined using the format: 4h 30m',
		description: 'error message displayed when goal duration is invalid',
	},
	openTipForGoalDurationFormat: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.open-tip-for-goal-duration-format',
		defaultMessage: 'E.g. 4h 30m',
		description: 'open tip for goal duration format',
	},
	noTarget: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.no-target',
		defaultMessage: 'No target',
		description: 'empty target goal',
	},
	durationInHours: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.duration-in-hours',
		defaultMessage: '{duration}h',
		description: 'duration displayed in Hours',
	},
	durationInMinutes: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.duration-in-minutes',
		defaultMessage: '{duration}m',
		description: 'duration displayed in Minutes',
	},
	selectDuration: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.select-duration',
		defaultMessage: 'Enter duration',
		description: 'Aria label for duration textfield',
	},
});
